export default __webpack_public_path__ + "static/media/Bottom-Arrow.81d8d27a.svg";